package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_05_03_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-05-03")
@Composable
public fun Log_2025_05_03(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Woes of Home Ownership by Flar’Melkhis",
        ogTitle = "Woes of Home Ownership by Flar’Melkhis",
        date = LocalDate(2_025, 5, 3),
        aiHint = "Title and description are a joke",
        ogDescription = "Water leaking into the basement causes a dank and moldy smell. Wild animals crawl inside and die under the floor then rot. The wet bandits vandalize your home, and try to steal your trinkets.",
        ogImage = "ai/2025-05-03.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "shimmer-5", dateString = "Shimmer 5")
        Log_2025_05_03_Day_1()
        SessionMediaItem(
            video = "videos/decade.mp4",
        )
    }
}
